export const errorMessages = {
  NO_TOKEN: 'NO_TOKEN',
  LOGIN_ERROR: 'LOGIN_ERROR',
  LOGIN_WRONG_FORMAT: 'LOGIN_WRONG_FORMAT',
  FETCH_ERROR: 'FETCH_ERROR',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  PASS_INCORRECT: 'PASSWORD_INCORRECT'
}
